interface EnvConfig {
    REACT_APP_API_ENDPOINT?: string;
}

declare global {
    interface Window {
        ENV: EnvConfig | string | undefined;
    }
}
/**
 * Retire un éventuel slash final pour éviter les "//" lors des concaténations
 * (ex: API_ENDPOINT="http://host/api/" + "/fl" -> "http://host/api//fl").
 */
const stripTrailingSlash = (value: string | undefined): string | undefined =>
    value ? value.replace(/\/+$/, "") : value;

export class AppSettings {
    public static API_ENDPOINT = stripTrailingSlash(
        (!window.ENV || window.ENV === "ENV")
            ? process.env.REACT_APP_API_ENDPOINT
            : (window.ENV as EnvConfig).REACT_APP_API_ENDPOINT,
    );
    public static API_CV = "/cv";
    public static API_FREELANCERIE = "/fl";

    public static Freelancerie = {
        Calendar: {
            // Palette alignée sur la légende "Financial Atelier" (cf. docs/stitch/planning.png)
            COLOR_HOLIDAY: "#E74C3C",       // Vacances — rouge
            COLOR_WORKED: "#27AE60",        // Contrats / jours travaillés — vert
            COLOR_FERIE: "#8E44AD",         // Jours fériés — violet
            COLOR_CRITIC: "#F39C12",        // Alerte revenu max — orange
            COLOR_CURRENT_DAY: "#FFDBAF",   // Aujourd'hui — or primaire
            COLOR_WEEKEND: "#7F8C8D",       // Weekends — gris
            COLOR_URSSAF: "#FFB74D",        // Échéances URSSAF — or container
        },
    };
}
